module.exports = __webpack_public_path__ + "img/service-banner7.30e8c503.png";